import './Main.css'

import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useWizard } from '@/common/wizard/wizard'
import { useAppContext } from '@/context/app'
import { WizardData } from './Model'
import { StaticPaginatedTable, StaticPaginatedTableState } from '@/components/search/StaticPaginatedTable'
import { TimeDHM } from '@/components/Elements/time'
import { secondsToDHM } from '@/common/time'
import { fetchPDF } from '@/common/fetch'
import { MachineName } from '@/components/machine'

export interface MachineRange {
  machineId: string;
  manufacturer: string;
  category: string;
  model: string;
  internalNumber: string;
  onFireRatio: number;
  totalActive: number;
  totalOnFire: number;
  totalBuckets: number;
  minMth?: number | null;
  maxMth?: number | null;
}

const tenMinInSec = 60 * 10

export const MachinesReportWizardResult = () => {
  const { services, session, translates } = useAppContext()
  const { wizardData, updateWizardData, nextStep } = useWizard<WizardData>()
  const [data, setData] = useState<MachineRange[]>()
  const [pagginationState, setPagginationState] = useState<StaticPaginatedTableState>({
    pageNumber: 1,
    pageSize: 5
  })

  function refresh() {
    services.session.fetchWithToken(`/api/communal/my/reports/machinesranking?from=${wizardData.from.toISOString()}&to=${wizardData.to.toISOString()}`).then((response) => {
      return response.json()
    }).then((data: MachineRange[]) => {
      data ||= []
      setData(data.sort((a, b) => b.onFireRatio - a.onFireRatio))
    })
  }

  function loadPDF() {
    fetchPDF({
      url: `/api/communal/my/reports/machinesranking/pdf?from=${wizardData.from.toISOString()}&to=${wizardData.to.toISOString()}&lang=${session?.user.lang}`,
      fileName: "machinesranking.pdf",
      services
    })
  }

  useEffect(refresh, [])

  const top5 = useMemo(() => {
    if (!data) return [];
    return [...data].sort((a, b) => b.onFireRatio - a.onFireRatio).slice(0, 5);
  }, [data]);

  const bottom5 = useMemo(() => {
    if (!data) return [];
    return [...data].sort((a, b) => a.onFireRatio - b.onFireRatio).slice(0, 5);
  }, [data]);

  if (translates === undefined || wizardData === undefined || data === undefined) {
    return <div className='spinner'></div>
  }


  function headerRow(key: string, transKey?: string) {
    if (translates === undefined || wizardData === undefined) {
      return null
    }
    transKey = transKey ? transKey : key
    return <div className='hcol'>
      {translates.for('report.machinesranking.summary.table.' + transKey)}
    </div>
  }

  const renderTable = (
    data: MachineRange[],
    state: StaticPaginatedTableState,
    setPagginationState: React.Dispatch<React.SetStateAction<StaticPaginatedTableState>> | undefined
  ) => {
    return <StaticPaginatedTable<MachineRange>
      data={data}
      parentState={state}
      setParentState={setPagginationState}
      header={() => <>
        {headerRow('machinename', 'machinename')}
        {headerRow('onFireRatio', 'on_fire_ratio')}
        {headerRow('onFireTime', 'total_on_fire')}
        {headerRow('activeTime', 'total_active')}
        {headerRow('activeTime', 'diff_mth')}


                    {/* "on_fire_ratio": "Procentowy czas pracy",
                    "total_active": "Aktywny czas",
                    "total_on_fire": "Czas pracy",
                    "min_mth": "Początkowa liczba roboczogodzin",
                    "max_mth": "Końcowy liczba roboczogodzin" */}
      </>}
      row={(row) => {
        const openDetails = () => {
          const url = `${window.location.origin}/communal/statistics/machines?length=1d&machine=${row.machineId}`;
          window.open(url, '_blank');
        }
        return <>
          <div className={`col`} onClick={openDetails}>
            <MachineName row={{
              internalNumber: row.internalNumber,
              type: {
                category: row.category,
                manufacturer: row.manufacturer,
                model: row.model
              }
            }} />
          </div>
          <div className={`col`} onClick={openDetails}>{(row.onFireRatio*100).toFixed(2)}%</div>
          <div className={`col`} onClick={openDetails}>
            <TimeDHM dhm={secondsToDHM(row.totalOnFire * tenMinInSec)} translates={translates} />
          </div>
          <div className={`col`} onClick={openDetails}>
            <TimeDHM dhm={secondsToDHM(row.totalActive * tenMinInSec)} translates={translates} />
          </div>
          <div className={`col`} onClick={openDetails}>{row.maxMth && row.minMth ? row.maxMth-row.minMth : '-'}</div>
        </>
      }}
      translates={translates}
    />
  }

  return <>
    <div>
      <h2>{translates.for('report.machinesranking.summary.title')}</h2>

      <h3>{translates.for('report.machinesranking.summary.top_title')}</h3>
      {renderTable(top5, { pageNumber: 1, pageSize: 5 }, undefined)}

      <h3>{translates.for('report.machinesranking.summary.bottom_title')}</h3>
      {renderTable(bottom5, { pageNumber: 1, pageSize: 5 }, undefined)}

      <h3>{translates.for('report.machinesranking.summary.all_title')}</h3>
      {renderTable(data, pagginationState, setPagginationState)}

      <div className='right-btns right-btns-margin'>
        <button type="button" className='btn btn-next' onClick={loadPDF}>{translates.for('report.machinesranking.wizard.gen_pdf')}</button>
      </div>
    </div>
  </>
}